import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'

export function downloadTmpExcel(cusId) {
  return request({
    url: urlPrefix + '/meritManage/downloadTmpExcel?cusId=' + cusId,
    method: 'get',
    responseType: 'arraybuffer',
  })
}
//创建批次
export function importExcel(data, params) {
  return request({
    url: urlPrefix + '/meritManage/importExcel',
    method: 'post',
    data,
    params
  });
}
//加载数据
export function getLoadBatch(obj) {
  return request({
    url: urlPrefix+'/meritManage/loadBatch',
    method: 'post',
    data: obj
  });
}
//加载数据
export function getLoadBatchData(obj) {
  return request({
    url: urlPrefix+'/meritManage/loadBatchData',
    method: 'post',
    data: obj
  });
}
//加载数据
export function getLoadBatchDataForHr(obj) {
  return request({
    url: urlPrefix+'/meritManage/loadBatchDataForHr',
    method: 'post',
    data: obj
  });
}


//导出
export function exportExcle(id) {
  return request({
    url: urlPrefix + '/meritManage/exportExcle',
    method: 'get',
    responseType: 'arraybuffer',
    params:{
      batchId: id
    }
  });
}

//导出ForHR
export function exportExcleHR(obj) {
  return request({
    url: urlPrefix + '/meritManage/exportExcleHR',
    method: 'post',
    responseType: 'arraybuffer',
    data: obj
  });
}

export function deleteBatch(obj) {
  return request({
    url: urlPrefix+'/meritManage/delete',
    method: 'post',
    data: obj
  });
}

export function updateDetail(obj) {
  return request({
    url: urlPrefix+'/meritManage/update',
    method: 'post',
    data: obj
  });
}

export function addDetail(obj) {
  return request({
    url: urlPrefix+'/meritManage/add',
    method: 'post',
    data: obj
  });
}

export function submitBatch(obj) {
  return request({
    url: urlPrefix+'/meritManage/submitBatch',
    method: 'post',
    data: obj
  });
}


export function returnBatch(obj) {
  return request({
    url: urlPrefix+'/meritManage/returnBatch',
    method: 'post',
    data: obj
  });
}
